import { Injectable } from '@angular/core';

import { FsMap, FsMapMarker, FsMarker } from '@lib/geo/map';

@Injectable({
  providedIn: 'root',
})
export class AppliancesMapService {
  public setupMap(map: FsMap, style: string, coordinates: number[], zoom: number): void {
    map.setStyle(style);
    map.setZoom(zoom);
    map.setCenter(coordinates);
  }

  public createMarker(map: FsMap, coordinates: number[]): FsMarker {
    const marker = new FsMapMarker(map, {
      lonLat: {
        lon: coordinates[0],
        lat: coordinates[1],
      },
      icon: {
        fontSet: 'fs', // Keep this to satisfy the type system
        fontIcon: '', // Keep empty to prioritize the URL
        url: 'assets/fusus-icons/PNG/building-marker.png',
      },
    });

    map.addMarker(marker.getMarker() as FsMarker);
    return marker.getMarker() as FsMarker;
  }
}
